module.exports = __webpack_public_path__ + "img/logo-gfs-cloud-footer.02d1d6de.svg";